import {filterTables} from "@vpsoftware/vprealestate-www";

export function initPropertiesFilters() {
    let flatTable = document.querySelector('#flat-table');
    let garageTable = document.querySelector('#garage-table');
    let premiseTable = document.querySelector('#premise-table');
    let cellarTable = document.querySelector('#cellar-table');
    const tables = [flatTable, garageTable, premiseTable, cellarTable].filter(table => !!table);
    
    tables.forEach(table => {
        table.querySelector<HTMLInputElement>('.show-sold')?.addEventListener('change', () => {
            invokeFilterTable();
        });
    });

    let isFlat = document.querySelector<HTMLInputElement>('#IsFlat');
    let isGarage = document.querySelector<HTMLInputElement>('#IsGarage');
    let isPremise = document.querySelector<HTMLInputElement>('#IsPremise');
    let isSale = document.querySelector<HTMLInputElement>('#IsSale');
    let floor = document.querySelector<HTMLSelectElement>('#floor');
    let minPrice = document.querySelector<HTMLSelectElement>('#minPrice');
    let maxPrice = document.querySelector<HTMLSelectElement>('#maxPrice');
    let minRooms = document.querySelector<HTMLSelectElement>('#minRooms');
    let maxRooms = document.querySelector<HTMLSelectElement>('#maxRooms');
    let minArea = document.querySelector<HTMLSelectElement>('#minArea');
    let maxArea = document.querySelector<HTMLSelectElement>('#maxArea');

    function invokeFilterTable() {
        if (!isFlat.checked && !isGarage.checked && !isPremise.checked) {
            tables.forEach(table => table.classList.remove('d-none'));
        }
        else {
            cellarTable?.classList.add('d-none');
            !isFlat.checked
                ? flatTable?.classList.add('d-none') : flatTable?.classList.remove('d-none');
            !isGarage.checked
                ? garageTable?.classList.add('d-none') : garageTable?.classList.remove('d-none');
            !isPremise.checked
                ? premiseTable?.classList.add('d-none') : premiseTable?.classList.remove('d-none');
        }
        
        const defaultValues = [Number.MAX_SAFE_INTEGER, 0]
        let [minPriceValue, maxPriceValue] = defaultValues;
        let [minRoomsValue, maxRoomsValue] = defaultValues;
        let [minAreaValue, maxAreaValue] = defaultValues;
        tables.forEach(table => {
            const showSold = table.querySelector<HTMLInputElement>('.show-sold')?.checked ?? true;
            filterTables(`#${table.id}:not(.d-none) table.offer-table`,
                obj => {
                    minPriceValue = minPriceValue > obj.tp ? obj.tp : minPriceValue;
                    maxPriceValue = maxPriceValue < obj.tp ? obj.tp : maxPriceValue;
                    minRoomsValue = minRoomsValue > obj.tr ? obj.tr : minRoomsValue;
                    maxRoomsValue = maxRoomsValue < obj.tr ? obj.tr : maxRoomsValue;
                    minAreaValue = minAreaValue > obj.a ? obj.a : minAreaValue;
                    maxAreaValue = maxAreaValue < obj.a ? obj.a : maxAreaValue;
                    let meetsCriteria = true;
                    meetsCriteria = meetsCriteria && (showSold || obj.stat !== 2);
                    if (floor.value !== '')
                        meetsCriteria = meetsCriteria && obj.f + '' === floor.value;
                    if (isSale.checked)
                        meetsCriteria = meetsCriteria && obj.top > obj.tp;
                    if (minPrice.value !== '')
                        meetsCriteria = meetsCriteria && obj.tp >= minPrice.value;
                    if (maxPrice.value !== '')
                        meetsCriteria = meetsCriteria && obj.tp <= maxPrice.value;
                    if (minRooms.value !== '')
                        meetsCriteria = meetsCriteria && obj.tr >= minRooms.value;
                    if (maxRooms.value !== '')
                        meetsCriteria = meetsCriteria && obj.tr <= maxRooms.value;
                    if (minArea.value !== '')
                        meetsCriteria = meetsCriteria && obj.a >= minArea.value;
                    if (maxArea.value !== '')
                        meetsCriteria = meetsCriteria && obj.a <= maxArea.value;
                    return meetsCriteria;
                })
                ? table.classList.remove('d-none') : table.classList.add('d-none');
        });

        document.querySelectorAll("table.offer-table .table-details").forEach(toggleElement =>{
            toggleElement.classList.toggle('open', false);
            toggleElement.closest('tr').nextElementSibling.classList.remove('d-none');
            toggleElement.closest('tr').nextElementSibling.classList.remove('more-info-house-open');
        });
        
        updateRange(minPrice, maxPrice, minPriceValue, maxPriceValue);
        updateRange(minRooms, maxRooms, minRoomsValue, maxRoomsValue);
        updateRange(minArea, maxArea, minAreaValue, maxAreaValue);
        
        if (tables.every(table => table.classList.contains('d-none'))) {
            document.querySelector('#noResults').classList.remove('d-none');
        }
        else {
            document.querySelector('#noResults').classList.add('d-none');
        }
    }
    
    document.querySelectorAll<HTMLElement>('.floor-button').forEach(el => {
        el.addEventListener('click', () => {
            floor.value = el.dataset['level'];
            invokeFilterTable();
        })
    })
    
    floor.addEventListener('change', () => {
        if (floor.value === '') {
            document.querySelectorAll('.floor-button').forEach(el => el.classList.remove('checked'));
            document.querySelector('#floor-plan-container').innerHTML = '';
            return
        }
        
        document.querySelector<HTMLElement>(`.floor-button[data-level="${floor.value}"]`).click();
    });
    
    [isFlat, isGarage, isPremise,
        isSale,
        floor,
        minPrice, maxPrice,
        minRooms, maxRooms,
        minArea, maxArea].forEach(el => el.addEventListener('change', invokeFilterTable));
    
    initHideFilters();
    
    invokeFilterTable();
}

function initHideFilters() {
    document.querySelector('.hide-filters').addEventListener('click', (e) => {
        e.preventDefault();
        (e.currentTarget as any).classList.add('d-none');
        document.querySelector('.show-filters').classList.remove('d-none');
        document.querySelectorAll('.type-filter, .other-filters').forEach(el => el.classList.add('d-none'));
    })
    document.querySelector('.show-filters').addEventListener('click', (e) => {
        e.preventDefault();
        (e.currentTarget as any).classList.add('d-none');
        document.querySelector('.hide-filters').classList.remove('d-none');
        document.querySelectorAll('.type-filter, .other-filters').forEach(el => el.classList.remove('d-none'));
    });
}

function updateRange(min: HTMLSelectElement, max: HTMLSelectElement, minValue: number, maxValue: number) {
    Array.from(min.options).filter(option => option.value).forEach((option, index, array) => {
        option.classList.remove('d-none');
        if ((index + 1 < array.length && Number(option.value) < minValue && Number(array[index + 1].value) <= minValue) ||
            (Number(option.value) > maxValue)) {
            option.classList.add('d-none');
        }
    });
    Array.from(max.options).filter(option => option.value).forEach((option, index, array) => {
        option.classList.remove('d-none');
        if ((Number(option.value) < minValue) ||
            (index -1 >= 0 && Number(option.value) > maxValue && Number(array[index - 1].value) >= maxValue)) {
            option.classList.add('d-none');
        }
    });
}